import { render, staticRenderFns } from "./PartnerProfitOrderList.vue?vue&type=template&id=bf21b1c8&scoped=true&"
import script from "./PartnerProfitOrderList.vue?vue&type=script&lang=js&"
export * from "./PartnerProfitOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf21b1c8",
  null
  
)

export default component.exports